{
  "name": "taxtank",
  "version": "0.0.0",
  "scripts": {
    "ng": "ng",
    "start": "ng serve",
    "chat:server": "npm --prefix server run dev",
    "chat:test": "npm --prefix server test",
    "chat:typecheck": "npm --prefix server run typecheck",
    "build": "ng build",
    "lint": "ng lint",
    "e2e": "ng e2e -c local",
    "test": "ng test",
    "prod": "ng build -c production && make -f sentry/Makefile",
    "stage": "ng build -c stage && make -f sentry/Makefile",
    "dev": "ng build -c dev && make -f sentry/Makefile",
    "local:build": "ng build -c local",
    "local": "ng serve -c local",
    "watch": "node ./node_modules/@angular/cli/bin/ng serve -c local",
    "install:core": "npm install taxtank-core@latest",
    "install:core:local": "npm install file:../tt-core/dist/tt-core",
    "cypress:open": "cypress open",
    "cypress:run": "cypress run"
  },
  "private": true,
  "engines": {
    "node": "^22.22.3 || ^24.15.0 || ^26.0.0"
  },
  "dependencies": {
    "@angular/animations": "22.1.0",
    "@angular/cdk": "22.1.0",
    "@angular/common": "22.1.0",
    "@angular/compiler": "22.1.0",
    "@angular/core": "22.1.0",
    "@angular/forms": "22.1.0",
    "@angular/material": "22.1.0",
    "@angular/material-luxon-adapter": "22.1.0",
    "@angular/platform-browser": "22.1.0",
    "@angular/platform-browser-dynamic": "22.1.0",
    "@angular/router": "22.1.0",
    "@auth0/angular-jwt": "^5.2.0",
    "@basiq/basiq-connect-control": "^1.0.72",
    "@copilotkit/angular": "^0.6.0",
    "@copilotkit/channels": "0.12.0",
    "@copilotkit/runtime": "^1.83.0",
    "@fullcalendar/angular": "^6.1.21",
    "@fullcalendar/core": "^6.1.21",
    "@fullcalendar/daygrid": "^6.1.21",
    "@fullcalendar/interaction": "^6.1.21",
    "@fullcalendar/list": "^6.1.21",
    "@ng-idle/core": "^16.0.0",
    "@ngx-translate/core": "^18.0.0",
    "@ngx-translate/http-loader": "^18.0.0",
    "@primeng/themes": "^21.0.4",
    "@rxweb/generics": "^0.0.1-4",
    "@rxweb/reactive-form-validators": "^13.0.1",
    "@sentry/angular": "^10.63.0",
    "@sentry/browser": "^10.63.0",
    "@sentry/cli": "^2.47.1",
    "@stripe/stripe-js": "^4.2.0",
    "@types/facebook-js-sdk": "^3.3.11",
    "@types/gapi": "^0.0.47",
    "@types/gapi.auth2": "^0.0.61",
    "@types/mixpanel-browser": "^2.49.0",
    "adblock-checker": "^0.2.4",
    "angularx-qrcode": "^21.0.5",
    "bootstrap": "^5.3.3",
    "class-transformer": "^0.5.1",
    "event-source-polyfill": "^1.0.31",
    "file-saver": "^2.0.5",
    "highcharts": "^11.4.8",
    "html2pdf.js": "^0.14.0",
    "jose": "6.2.13",
    "jspdf": "^4.2.1",
    "jspdf-autotable": "^5.0.8",
    "leaflet": "^1.9.4",
    "leaflet.markercluster": "^1.5.3",
    "lodash": "^4.17.21",
    "luxon": "^3.7.2",
    "mixpanel-browser": "^2.49.0",
    "moment": "^2.30.1",
    "moment-range": "^4.0.2",
    "moment-timezone": "^0.5.48",
    "ng2-pdf-viewer": "^10.4.0",
    "ngx-mat-select-search": "^8.0.6",
    "ngx-moment": "^6.0.2",
    "ngx-pipes": "^3.2.2",
    "ngx-ui-tour-md-menu": "^17.0.0",
    "primeicons": "^6.0.1",
    "primeng": "^21.1.9",
    "primeng-sass-theme": "github:primefaces/primeng-sass-theme#main",
    "rxjs": "^7.8.1",
    "swiper": "^14.0.1",
    "taxtank-core": "^3.0.41",
    "tslib": "^2.8.1",
    "xlsx-js-style": "^1.2.0",
    "zone.js": "^0.15.0"
  },
  "devDependencies": {
    "@angular-eslint/builder": "^22.0.0",
    "@angular-eslint/eslint-plugin": "^22.0.0",
    "@angular-eslint/eslint-plugin-template": "^22.0.0",
    "@angular-eslint/schematics": "^22.0.0",
    "@angular-eslint/template-parser": "^22.0.0",
    "@angular/build": "22.1.2",
    "@angular/cli": "22.1.2",
    "@angular/compiler-cli": "22.1.0",
    "@angular/language-service": "22.1.0",
    "@angular/localize": "22.1.0",
    "@badeball/cypress-cucumber-preprocessor": "^26.0.0",
    "@bahmutov/cypress-esbuild-preprocessor": "^2.2.8",
    "@cypress/schematic": "^1.7.0",
    "@eslint/js": "^10.0.1",
    "@stylistic/eslint-plugin": "^5.10.0",
    "@types/file-saver": "^2.0.7",
    "@types/lodash": "^4.17.13",
    "@types/node": "^22.10.2",
    "@typescript-eslint/eslint-plugin": "^8.63.0",
    "@typescript-eslint/parser": "^8.63.0",
    "@typescript-eslint/utils": "^8.63.0",
    "@vitest/coverage-v8": "^4.1.10",
    "angular-eslint": "^22.0.0",
    "cypress": "^13.13.2",
    "cypress-file-upload": "^5.0.8",
    "eslint": "^10.6.0",
    "eslint-plugin-rxjs-angular-x": "^1.0.1",
    "eslint-plugin-rxjs-x": "^1.0.2",
    "istanbul-lib-instrument": "^6.0.3",
    "jsdom": "^30.0.1",
    "ts-node": "~7.0.0",
    "tsx": "^4.23.15",
    "typescript": "6.0.3",
    "typescript-eslint": "^8.63.0",
    "vitest": "^4.1.10"
  },
  "overrides": {
    "canvg": "4.0.3",
    "esbuild": "^0.28.1",
    "@babel/core": "^7.29.7",
    "elliptic": "^6.6.1",
    "qs": "^6.15.3",
    "ajv@>=7.0.0 <8.18.0": "^8.20.0",
    "uuid": "^11.1.1",
    "serialize-javascript": "^7.0.7",
    "diff": "^9.0.0",
    "@modelcontextprotocol/sdk": "^1.30.0",
    "@hono/node-server": "^2.0.5",
    "primeng": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common",
      "@angular/forms": "$@angular/forms",
      "@angular/router": "$@angular/router",
      "@angular/cdk": "$@angular/cdk",
      "@angular/platform-browser": "$@angular/platform-browser"
    },
    "angularx-qrcode": {
      "@angular/core": "$@angular/core",
      "@angular/common": "$@angular/common"
    },
    "mocha": {
      "minimatch": "^10.2.6",
      "glob": "^13.0.6"
    }
  },
  "cypress-cucumber-preprocessor": {
    "stepDefinitions": [
      "cypress/integration/[filepath]/**/*.{js,ts}",
      "cypress/integration/[filepath].{js,ts}",
      "cypress/integration/common/**/*.{js,ts}"
    ]
  }
}
